
import React, { useMemo, useRef } from 'react';
import { Card, ListView, Flex } from 'antd-mobile';
import { Error, Loading } from '.';
import { formatDate, formatBillUnit } from "../../../utils/utils";

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
});

function AgentList(props) {

  const { loading, errorMessage, companyList, handleAction } = props;
  const listRef = useRef();

  const dataSourceList = useMemo(() => dataSource.cloneWithRows(companyList), [companyList])

  const row = (item) => {
    return <Card key={item.Id} style={{ 
      marginBottom: '10px',
      padding: '10px 10px' 
    }}>
      <Card.Header
        title={item.AgentName || '代理商不存在'}
        extra={<span style={{ color: '#108ee9' }} onClick={() => handleAction(item)}>详情</span>}
      />
      <Card.Body style={{ paddingBottom: '10px' }}>
        <Flex className='flex'>
          <Flex.Item className='description-title'>ID</Flex.Item>
          <Flex.Item className='description-content'>{item.Id || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>域名</Flex.Item>
          <Flex.Item className='description-content'>{(item.Domain||[]).join(", ") || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>余额（元）</Flex.Item>
          <Flex.Item className='description-content'>{formatBillUnit(item.Balance) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>抽成</Flex.Item>
          <Flex.Item className='description-content'>0.03</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>有效状态</Flex.Item>
          <Flex.Item className='description-content'>{item.Enable === 1?'有效':'无效'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>创建时间</Flex.Item>
          <Flex.Item className='description-content'>{formatDate(item.CreateTime) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>操作人</Flex.Item>
          <Flex.Item className='description-content'>{item.Operator || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>备注</Flex.Item>
          <Flex.Item className='description-content'>{item.Remark || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>操作</Flex.Item>
          <Flex.Item className='description-content'>
            <a href={`/usms/addAgentUser?AgentId=${item.Id}`} style={{ color: 'rgb(16, 142, 233)' }} >去关联用户</a>
          </Flex.Item>
        </Flex>
      </Card.Body>
    </Card>
  }

  return (
    <Loading loading={loading} >
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              height: '100vh',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          />
        </>
      }
    </Loading>
  )
}

export default AgentList